import * as React from 'react';
import { ContentType } from 'actions/AutosuggestActions/Utils';
import SimpleImage from 'components/Common/Image/SimpleImage';
import getImageUrl from 'utils/getImageUrl';
import style from './itemTemplates.css';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import cx from 'classnames';
import get from 'lodash/get';
const getImageSize = () => {
    return {
        size: 32,
        className: style['image-container']
    };
};
const getImage = (suggestionValue) => {
    const imageUrl = (suggestionValue.imageUrl && getImageUrl(suggestionValue.imageUrl)) || '';
    if (!imageUrl) {
        return null;
    }
    const imageAttributes = getImageSize();
    return (<div className={imageAttributes.className}>
			<SimpleImage imgClassName={style['image']} size={imageAttributes.size} src={imageUrl}/>
		</div>);
};
const escapeRegExp = (query) => {
    return query.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
const getHighlightedTitleString = (query, title) => {
    const regExp = new RegExp(`(${escapeRegExp(query)})`, 'g');
    let highlightedTxt = [];
    let matches = title.split(regExp);
    if (matches.length > 0) {
        for (let i = 0; i <= matches.length; i++) {
            if (matches[i] === query) {
                highlightedTxt.push(<span key={i} className={style['highlighted']}>
						{matches[i]}
					</span>);
            }
            else {
                highlightedTxt.push(matches[i]);
            }
        }
    }
    else {
        return title;
    }
    return highlightedTxt;
};
// Checks whether the user query is valid for applying conditional styling
const isValidUserQuery = userTypedQuery => !!(userTypedQuery && userTypedQuery.trim());
const v4InfoTemplate = (suggestionValue, userTypedQuery) => {
    const title = userTypedQuery
        ? getHighlightedTitleString(userTypedQuery, suggestionValue.title)
        : suggestionValue.title;
    return (<div className={cx(style['info'], {
        [style['info-with-user-query']]: isValidUserQuery(userTypedQuery)
    })}>
			{title}
			{suggestionValue.subTitle && <div className={style['subtitle']}>{suggestionValue.subTitle}</div>}
		</div>);
};
const partitionTemplate = (suggestion) => {
    const value = suggestion.value;
    return (<div className={cx(style['partition'], style['title'])}>
			<div className={style['title']}>{value.title}</div>
		</div>);
};
const richCardTemplate = (suggestion, userTypedQuery) => {
    const value = suggestion.value;
    return (<React.Fragment>
			{getImage(value)}
			{v4InfoTemplate(value, userTypedQuery)}
		</React.Fragment>);
};
export const getTemplate = (suggestion, userTypedQuery = '') => {
    const template = get(suggestion, ['value', 'template']) || '';
    switch (template) {
        case WidgetTypeV4.AUTOSUGGEST_RICH_WIDGET:
        case WidgetTypeV4.AUTOSUGGEST_PRODUCT_WIDGET:
        case WidgetTypeV4.AUTOSUGGEST_CLP_WIDGET:
        case WidgetTypeV4.AUTOSUGGEST_QUERY_STORE_WIDGET:
        case WidgetTypeV4.AUTOSUGGEST_QUERY_WIDGET:
            return richCardTemplate(suggestion, userTypedQuery);
        case WidgetTypeV4.AUTOSUGGEST_PARTITION_WIDGET:
            return partitionTemplate(suggestion);
        default:
            return richCardTemplate(suggestion, userTypedQuery);
    }
};
export const getTemplateClass = (suggestion) => {
    const template = get(suggestion, ['value', 'template']) || '';
    const className = style['search-item'];
    let templateClass = '';
    switch (template) {
        case WidgetTypeV4.AUTOSUGGEST_RICH_WIDGET:
        case WidgetTypeV4.AUTOSUGGEST_PRODUCT_WIDGET:
        case WidgetTypeV4.AUTOSUGGEST_CLP_WIDGET:
        case WidgetTypeV4.AUTOSUGGEST_QUERY_STORE_WIDGET:
        case WidgetTypeV4.AUTOSUGGEST_QUERY_WIDGET:
            templateClass = cx(className, style['v4-store']);
            break;
        case WidgetTypeV4.AUTOSUGGEST_QUERY_WIDGET:
            templateClass = cx(className, style['v4-store'], style['query']);
            break;
        default:
            // no styles
            break;
    }
    const contentType = suggestion.value.contentType.toUpperCase();
    if (contentType === ContentType.HISTORY) {
        templateClass = cx(className, style['v4-store']);
        if (template === WidgetTypeV4.AUTOSUGGEST_QUERY_WIDGET) {
            templateClass = cx(templateClass, style['query']);
        }
    }
    else if (contentType === ContentType.TRENDING) {
        templateClass = cx(className, style['query']);
    }
    return templateClass;
};
